import React from 'react'
import uploadImage from '../../../images/Bodhi_Icon_UploadLogo.png';
import addImage from '../../../images/addImage.png';
import removeImage from '../../../images/removeImage.png';

const DetailsPanel = (props) => {
    const baseLink = localStorage.getItem('baseLink')
    const baseURL = baseLink + '/media/' + props.selectedImage;

    const handleLabelClick = (e) => {
        if (props.selectedImage !== '') {
            e.preventDefault();
        }
    }

    return (
        <div className="d-flex flex-row flex-wrap">
            <div className="p-4 col-md-10 col-12 order-2 order-md-1 order light-grey text-center text-md-left">
                <strong className=" bold" key="1"> {props.heading} </strong>
                <p className="text-capitalize ">{props.data}</p>
            </div>
            <div className="dark-grey col-md-2 order-1 order-md-2 col-12 " style={{ background: '#e0e0e0' }}>
                <label
                    htmlFor="image-1-input"
                    className="d-flex flex-row justify-content-center h-100 align-items-center text-white position-relative"
                    onClick={handleLabelClick}
                    style={{ cursor: props.selectedImage === '' ? 'pointer' : 'default' }}
                >
                    <input
                        className="display-none form-control-file"
                        type="file"
                        name="image-1-input"
                        id="image-1-input"
                        accept="image/*"
                        onChange={props.onImageSelected}
                        disabled={props.selectedImage !== ''}
                    />

                    {(props.selectedImage === '') &&
                        <img className="img-fluid m-3" width={"100px"} src={uploadImage} alt="Upload placeholder" />
                    }

                    {(props.selectedImage === '') &&
                        <img className="img-fluid position-absolute" style={{ bottom: '10px', right: '10px', height: '13%' }} src={addImage} alt="Add icon" />
                    }

                    {props.selectedImage !== '' &&
                        <img className="m-3 img-fluid" src={baseURL} alt="Selected image" />
                    }

                </label>
                {props.selectedImage !== '' &&
                    <img
                        onClick={props.onClickImg}
                        className="img-fluid position-absolute"
                        style={{ bottom: '15px', right: '15px', height: '13%', cursor: 'pointer' }}
                        src={removeImage}
                        alt="Remove icon"
                    />
                }
            </div>
        </div>
    );
};

export default DetailsPanel;


// WEBPACK FOOTER //
// ./src/_components/common/TableNew/details.jsx